import React, { Component } from 'react';

import { ThNavHeader } from './ThNavHeader';
import { ThNavFooter } from './ThNavFooter';
import { ThSharedComponentBenefit01 } from './ThSharedComponentBenefit01';
import ThUserMenu from './ThUserMenu';

import { getClientId } from './utils/analyticsclientIdUtils';
import { encryptData } from './utils/encryptionUtils';
import { API_URL } from './utils/constants';

export class ThUserReward extends Component {
    static displayName = ThUserReward.name;

    constructor(props) {
        super(props);
        this.state = {
            userData: null, // Initialize userData state to null
            barWidth: '1%', // Initial width value
            barwidth2: '5%', // Default width as a string
            bar2Label: '',
            transactionThismonth: [],
            transactionExpire: [],
            cssMtr01: false, // Default css hide/show for MTR promo info
            cssMtr02: false,
            cssMtrNew01: false,
            cssMtrNew02: false,
            cssMtrNew03: false,
            circleMeterColor01: 'circle-gray',
            circleMeterColor02: 'circle-gray',
            circleMeterColor03: 'circle-gray',
            circleMeterColor04: 'circle-gray',
            circleMeterColor05: 'circle-gray',
            promotions: [],
            rewards: [],
            transactionExpired: []
        };
    }

    componentDidMount() {
        // Retrieve data from session storage
        const userDataFromStorage = sessionStorage.getItem('userData');

        // Parse the data if it exists and set it to the component state
        if (userDataFromStorage) {
            this.setState({ userData: JSON.parse(userDataFromStorage) }, () => {
                // fetch CrmAuthGetRewardLevel             
                this.callApiGetRewardLevel(this.state.userData.loyaltyMemberId);

                // After setting the state, make the API call if userData is available
                if (this.state.userData && this.state.userData.loyaltyMemberId) {
                    this.callApiWithUserId(this.state.userData.loyaltyMemberId);
                    this.callApiWithUserId2(this.state.userData.loyaltyMemberId);
                }
            });
        }

        {
            // Google analytic
            const documentPath = "TH Reward"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
    }

    async callApiWithUserId(userId) {
        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = { UserId: userId, RefLang: "th", Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        const token = this.state.userData.token;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            const response = await fetch(`${API_URL}/api/CrmMemberStarRewardExpiration`, requestOptions);
            const data = await response.json();

            if (data) {
                if (data && Array.isArray(data)) {
                    //filter starRewardExpirations to separate This month and Other month
                    const currentMonth = new Date().getMonth();
                    const currentYear = new Date().getFullYear();

                    const prev = new Date(currentYear, currentMonth - 1, 1);
                    const prevMonth = prev.getMonth();
                    const prevYear = prev.getFullYear();

                    //const filteredThisMonth = data.filter(item => {
                    //    // Ensure expiryDate is a Date object
                    //    const expiryDate = new Date(item.expiryDate);
                    //    return expiryDate.getMonth() === currentMonth;
                    //});
                    //const sortedThismonthList = filteredThisMonth.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));
                    const filteredThisMonth = data.filter(item => {
                        const expiryDate = new Date(item.expiryDate);
                        return expiryDate.getMonth() === currentMonth && expiryDate.getFullYear() === currentYear;
                    });
                    const sortedThismonthList = filteredThisMonth.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));

                    //const filteredNotThismonth = data.filter(item => {
                    //    // Ensure expiryDate is a Date object
                    //    const expiryDate = new Date(item.expiryDate);
                    //    return expiryDate.getMonth() !== currentMonth;
                    //});
                    //const sortedExpireList = filteredNotThismonth.sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate));
                    const filteredNotThismonth = data.filter(item => {
                        const d = new Date(item.expiryDate);
                        const isThisMonth = d.getMonth() === currentMonth && d.getFullYear() === currentYear;
                        const isPrevMonth = d.getMonth() === prevMonth && d.getFullYear() === prevYear;
                        return !isThisMonth && !isPrevMonth;
                    });
                    const sortedExpireList = filteredNotThismonth.sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate));

                    //251026 -> adjust ux
                    const filteredExpired = data.filter(item => {
                        const expiryDate = new Date(item.expiryDate);
                        const previousMonth = new Date();
                        previousMonth.setMonth(previousMonth.getMonth() - 1);

                        return (
                            expiryDate.getMonth() === previousMonth.getMonth() &&
                            expiryDate.getFullYear() === previousMonth.getFullYear()
                        );
                    });
                    const sortedExpiredList = filteredExpired.sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate));

                    this.setState({
                        transactionThismonth: sortedThismonthList,
                        transactionExpire: sortedExpireList,
                        transactionExpired: sortedExpiredList
                    });
                }
                else
                {
                    console.error('Error data:none');
                }
            }
            else {
                console.error('Error data:');
            }
        } catch (error) {
            console.error('API call error :', error);
        } finally {

        }
    }

    async callApiWithUserId2(userId) {
        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        const payload = { LoyaltyMemberId: userId, RefLang: "th", Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        const token = this.state.userData.token;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            const response = await fetch(`${API_URL}/api/CrmMemberGetAllBenefit`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "00") {
                if (Array.isArray(data.promotionLists.promotions)) {
                    this.setState({ promotions: data.promotionLists.promotions });
                }

                if (Array.isArray(data.promotionLists.rewards)) {
                    const filteredRewards = data.promotionLists.rewards.filter(reward => reward.status !== "Expired");
                    this.setState({ rewards: filteredRewards });

                    //this.setState({ rewards: data.promotionLists.rewards });
                }
            }
            else {
                console.error('Error data:');
            }
        } catch (error) {
            console.error('API call error :', error);
        }
    }

    async callApiGetRewardLevel(userId) {
        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        const payload = { LoyaltyMemberId: userId, RefLang: "th", Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        const token = this.state.userData.token;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            const response = await fetch(`${API_URL}/api/CrmAuthGetRewardLevel`, requestOptions);
            const data = await response.json();

            if (data) {
                data.firstName = this.state.userData.firstName;
                this.setState({ userData: data });

                const starRewardBalance = parseFloat(data.starRewardBalance.replace(/,/g, ''));

                //Determine which MTR pro to show
                let cssMtr01, cssMtr02;
                let cssMtrNew01, cssMtrNew02, cssMtrNew03;
                switch (true) {
                    case starRewardBalance >= 100:
                        cssMtr01 = true; cssMtr02 = true;
                        cssMtrNew01 = true; cssMtrNew02 = true; cssMtrNew03 = true;
                        break;
                    case starRewardBalance >= 60:
                        cssMtr01 = true; cssMtr02 = true;
                        cssMtrNew01 = true; cssMtrNew02 = true; cssMtrNew03 = false;
                        break;
                    case starRewardBalance >= 20:
                        cssMtr01 = true; cssMtr02 = false;
                        cssMtrNew01 = false; cssMtrNew02 = false; cssMtrNew03 = false;
                        break;
                    default:
                        cssMtr01 = false; cssMtr02 = false;
                        cssMtrNew01 = false; cssMtrNew02 = false; cssMtrNew03 = false;
                        break;
                }

                // Determine data-width based on varValue using switch
                let dataWidth, circleMeterColor01, circleMeterColor02, circleMeterColor03, circleMeterColor04, circleMeterColor05;
                circleMeterColor01 = 'circle-gray';
                circleMeterColor02 = 'circle-gray';
                circleMeterColor03 = 'circle-gray';
                circleMeterColor04 = 'circle-gray';
                circleMeterColor05 = 'circle-gray';

                circleMeterColor01 = starRewardBalance >= 20 ? 'circle-green' : circleMeterColor01;
                circleMeterColor02 = starRewardBalance >= 60 ? 'circle-green' : circleMeterColor02;
                circleMeterColor03 = starRewardBalance >= 120 ? 'circle-green' : circleMeterColor03;
                circleMeterColor04 = starRewardBalance >= 160 ? 'circle-green' : circleMeterColor04;
                circleMeterColor05 = starRewardBalance >= 350 ? 'circle-green' : circleMeterColor05;

                switch (true) {
                    case starRewardBalance <= 5:
                        dataWidth = "1%";
                        break;
                    case starRewardBalance <= 10:
                        dataWidth = "4%";
                        break;
                    case starRewardBalance <= 20:
                        dataWidth = "12%";
                        break;
                    case starRewardBalance <= 30:
                        dataWidth = "13%";
                        break;
                    case starRewardBalance <= 40:
                        dataWidth = "15%";
                        break;
                    case starRewardBalance <= 50:
                        dataWidth = "20%";
                        break;
                    case starRewardBalance <= 60:
                        dataWidth = "31%";
                        break;
                    case starRewardBalance <= 70:
                        dataWidth = "34%";
                        break;
                    case starRewardBalance <= 80:
                        dataWidth = "37%";
                        break;
                    case starRewardBalance <= 90:
                        dataWidth = "40%";
                        break;
                    case starRewardBalance <= 100:
                        dataWidth = "43%";
                        break;
                    case starRewardBalance <= 110:
                        dataWidth = "44%";
                        break;
                    case starRewardBalance <= 120:
                        dataWidth = "51%";
                        break;
                    case starRewardBalance <= 140:
                        dataWidth = "52%";
                        break;
                    case starRewardBalance <= 150:
                        dataWidth = "59%";
                        break;
                    case starRewardBalance <= 160:
                        dataWidth = "71%";
                        break;
                    case starRewardBalance <= 190:
                        dataWidth = "74%";
                        break;
                    case starRewardBalance <= 250:
                        dataWidth = "82%";
                        break;
                    case starRewardBalance <= 270:
                        dataWidth = "84%";
                        break;
                    case starRewardBalance <= 300:
                        dataWidth = "86%";
                        break;
                    case starRewardBalance <= 320:
                        dataWidth = "90%";
                        break;
                    case starRewardBalance <= 350:
                        dataWidth = "93%";
                        break;
                    case starRewardBalance <= 400:
                        dataWidth = "97%";
                        break;
                    case starRewardBalance > 400:
                        dataWidth = "100%";
                        break;
                    default:
                        dataWidth = "1%";
                        break;
                }

                // Set data-width attribute
                window.$(".bar").attr("data-width", dataWidth);

                // Use jQuery directly as it's globally available
                window.$(function () {
                    window.$(".accordion-image img:eq(0)").nextAll().hide();
                    window.$(".accordion350tab button").click(function (e) {
                        var imageId = window.$(this).attr('data-image');
                        window.$(".accordion-image #" + imageId).show().siblings().hide();
                    });

                    window.$(".bar").each(function () {
                        window.$(this).find(".bar-inner").animate({
                            width: window.$(this).attr("data-width")
                        }, 2000);
                    });
                });

                let dataWidth2;
                const starBalance = 300 - parseFloat(data.starsToNextLevel);
                switch (true) {
                    case starBalance <= 5:
                        dataWidth2 = "1%";
                        break;
                    case starBalance <= 20:
                        dataWidth2 = "7%";
                        break;
                    case starBalance <= 30:
                        dataWidth2 = "13%";
                        break;
                    case starBalance <= 50:
                        dataWidth2 = "25%";
                        break;
                    case starBalance <= 100:
                        dataWidth2 = "40%";
                        break;
                    case starBalance <= 150:
                        dataWidth2 = "50%";
                        break;
                    case starBalance <= 200:
                        dataWidth2 = "70%";
                        break;
                    case starBalance <= 250:
                        dataWidth2 = "85%";
                        break;
                    case starBalance <= 280:
                        dataWidth2 = "95%";
                        break;
                    case starBalance >= 300:
                        dataWidth2 = "100%";
                        break;
                    default:
                        dataWidth2 = "1%";
                        break;
                }

                this.setState({ barwidth2: `${dataWidth2}`, bar2Label: starBalance, circleMeterColor01: circleMeterColor01, circleMeterColor02: circleMeterColor02, circleMeterColor03: circleMeterColor03, circleMeterColor04: circleMeterColor04, circleMeterColor05: circleMeterColor05, cssMtr01: cssMtr01, cssMtr02: cssMtr02, cssMtrNew01: cssMtrNew01, cssMtrNew02: cssMtrNew02, cssMtrNew03: cssMtrNew03 });
            }
            else {
                console.error('API call with no data return');
            }
        } catch (error) {
            console.error('API call error :', error);
        }
    }

    render() {
        const { userData, barWidth, barwidth2, bar2Label, transactionThismonth, transactionExpire, cssMtr01, cssMtr02, promotions, rewards, circleMeterColor01, circleMeterColor02, circleMeterColor03, circleMeterColor04, circleMeterColor05, transactionExpired, cssMtrNew01, cssMtrNew02, cssMtrNew03 } = this.state;

        return (
            <>
                <ThNavHeader />

                {/* Render the user data */}
                {userData && (
                    <main id="main">
                        <section id="profile_section" className="profileBanner keyboardFocus" aria-label="Profile" tabIndex={-1}>
                            <ThUserMenu />
                        </section>
                        <section className="section-dashboard overflow-hidden pb-5">
                            <div className="container mt-4">
                                <div className="row mb-5 px-2">
                                    <div className="col-md-6">
                                        <div className="row mb-5 px-2">
                                            <div className="col-md-12">
                                                <h3 className="fw-semibold">สถานะการสะสมดาว</h3>
                                                <div className="card mt-3 p-3 p-md-4">
                                                    <div className="rewards level_gold">
                                                        <div className="rewards__container pe-4">
                                                            <div className="position-relative">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div>
                                                                            <span className="rewards_details--icon_container fs-1">
                                                                                <strong>{userData.starRewardBalance}</strong> <img src="media/rewards/SR_Stars_green_large.svg" alt="Green" style={{ width: '24px' }} />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h4 className="mt-3">ดาวที่ได้รับเพื่อแลกรับสิทธิประโยชน์</h4>
                                                            </div>
                                                            <div className="star-earned-bar star-green">
                                                                <div className="bar" data-width={barWidth}>
                                                                    <div className="bar-inner" />
                                                                    <div className="text-num t20"><div className={circleMeterColor01} />20</div>
                                                                    <div className="text-num t60"><div className={circleMeterColor02} />60</div>
                                                                    <div className="text-num t120"><div className={circleMeterColor03} />120</div>
                                                                    <div className="text-num t160"><div className={circleMeterColor04} />160</div>
                                                                    <div className="text-num t350"><div className={circleMeterColor05} />350</div>
                                                                </div>
                                                            </div>
                                                            <p className="d-none">*{userData.starRewardBalance} ดวง จะหมดอายุภายในวันที่ {userData.anniversaryDate}</p>
                                                            <div className="mb-3">
                                                                <a href="#" className="btn btn-outline-green rounded-pill" data-bs-toggle="modal" data-bs-target="#Rewards_details">รายละเอียด</a>
                                                                {/* The Modal */}
                                                                <div className="modal" id="Rewards_details">
                                                                    <div className="modal-dialog modal-xl modal-dialog-centered">
                                                                        <div className="modal-content">
                                                                            {/* Modal Header */}
                                                                            <div className="modal-header">
                                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                                                                            </div>
                                                                            {/* Modal body */}
                                                                            <div className="modal-body">
                                                                                <ThSharedComponentBenefit01 />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-5 px-2">
                                            <div className="col-md-12">
                                                <h3 className="fw-semibold">สถานะสมาชิก</h3>
                                                <div className="card mt-3 p-3 p-md-4">
                                                    <div className="rewards level_gold">
                                                        <div className="rewards__container">
                                                            <div className="position-relative">
                                                                <h4 className="text-green-1 mt-3 mb-3 fw-semibold">ระดับกรีน</h4>
                                                            </div>
                                                            <div className="row g-4 align-items-center">
                                                                <div className="col-9 col-md-10">
                                                                    <div className="membership-status mb-3">
                                                                        <div className="skills star-status status-green" style={{ width: barwidth2 }}><img src="media/rewards/SR_Stars_green_large.svg" alt="Green" className="img-star-status d-none" /></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 col-md-2 mt-3 pe-0">
                                                                    <span className="text-black">{bar2Label}/300</span>
                                                                </div>
                                                            </div>
                                                            <p className="mb-3">สะสมดาวอีก {userData.starsToNextLevel} ดวง ภายใน {userData.anniversaryDate} เพื่อปรับระดับเป็น <span className="gold_text">โกลด์</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-5 px-2">
                                            <div className="col-md-12">
                                                <h3 className="fw-semibold">สิทธิประโยชน์ของคุณ</h3>
                                                {cssMtr01 && (
                                                    <div className="card mt-3 p-3">
                                                        <div className="row">
                                                            <div className="col-3 col-md-2 text-center p-0">
                                                                <div className="m-0"><img src="media/rewards/mtr/ReReward-for-MTR-20-Stars.png" alt="Free upsize" className="img-fluid" /></div>
                                                            </div>
                                                            <div className="col-9 col-md-10">
                                                                <p className="mb-1 text-green-1"><strong>อัปไซซ์ฟรี</strong></p>
                                                                <p className="text-black small mb-1">แลกรับเครื่องดื่มที่ชื่นชอบกับขนาดที่ใหญ่ขึ้น (12 ออนซ์/16 ออนซ์)</p>
                                                                <div>
                                                                    <p className="mt-2 mb-0 text-gray-2">
                                                                        <span>20</span> <img src="media/rewards/SR_Stars_gold_large.svg" alt="Gold" className="ms-1 star-after-point" style={{ width: '18px', marginTop: '-7px' }} />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {cssMtrNew01 && (
                                                    <div className="card mt-3 p-3">
                                                        <div className="row">
                                                            <div className="col-3 col-md-2 text-center p-0">
                                                                <div className="m-0"><img src="media/rewards/mtr/26-ReReward-for-MTR-30-Stars.png" alt="" className="img-fluid rounded-circle" /></div>
                                                            </div>
                                                            <div className="col-9 col-md-10">
                                                                <p className="mb-1 text-green-1"><strong>30 Stars Delivery Fee</strong></p>
                                                                <p className="text-black small mb-1">Redeem 30 Stars Delivery Fee</p>
                                                                <div>
                                                                    <p className="mt-2 mb-0 text-gray-2">
                                                                        <span>30</span> <img src="media/rewards/SR_Stars_green_large.svg" alt="Gold" className="ms-1 star-after-point" style={{ width: '18px', marginTop: '-7px' }} />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {cssMtr02 && (
                                                    <div className="card mt-3 p-3">
                                                        <div className="row">
                                                            <div className="col-3 col-md-2 text-center p-0">
                                                                <div className="m-0"><img src="media/rewards/mtr/ReReward-for-MTR-60-Stars.png" alt="25% off drink/ food per item" className="img-fluid" /></div>
                                                            </div>
                                                            <div className="col-9 col-md-10">
                                                                <p className="mb-1 text-green-1"><strong>ส่วนลด 25% เครื่องดื่ม/ขนม</strong></p>
                                                                <p className="text-black small mb-1">แลกรับส่วนลด 25% สำหรับเครื่องดื่ม 1 แก้ว หรือขนม 1 ชิ้น</p>
                                                                <div>
                                                                    <p className="mt-2 mb-0 text-gray-2">
                                                                        <span>60</span> <img src="media/rewards/SR_Stars_gold_large.svg" alt="Gold" className="ms-1 star-after-point" style={{ width: '18px', marginTop: '-7px' }} />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {cssMtrNew02 && (
                                                    <div className="card mt-3 p-3">
                                                        <div className="row">
                                                            <div className="col-3 col-md-2 text-center p-0">
                                                                <div className="m-0"><img src="media/rewards/mtr/26-ReReward-for-MTR-60-Stars.png" alt="" className="img-fluid rounded-circle" /></div>
                                                            </div>
                                                            <div className="col-9 col-md-10">
                                                                <p className="mb-1 text-green-1"><strong>60 Stars Delivery Fee</strong></p>
                                                                <p className="text-black small mb-1">Redeem 60 Stars Delivery Fee</p>
                                                                <div>
                                                                    <p className="mt-2 mb-0 text-gray-2">
                                                                        <span>60</span> <img src="media/rewards/SR_Stars_green_large.svg" alt="Gold" className="ms-1 star-after-point" style={{ width: '18px', marginTop: '-7px' }} />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {cssMtrNew03 && (
                                                    <div className="card mt-3 p-3">
                                                        <div className="row">
                                                            <div className="col-3 col-md-2 text-center p-0">
                                                                <div className="m-0"><img src="media/rewards/mtr/26-ReReward-for-MTR-100-Stars.png" alt="" className="img-fluid rounded-circle" /></div>
                                                            </div>
                                                            <div className="col-9 col-md-10">
                                                                <p className="mb-1 text-green-1"><strong>650 THB Whole Bean Discount</strong></p>
                                                                <p className="text-black small mb-1">Get 650 Baht off when purchase whole bean products</p>
                                                                <div>
                                                                    <p className="mt-2 mb-0 text-gray-2">
                                                                        <span>100</span> <img src="media/rewards/SR_Stars_green_large.svg" alt="Gold" className="ms-1 star-after-point" style={{ width: '18px', marginTop: '-7px' }} />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {cssMtr01 === false && cssMtr02 === false && cssMtrNew01 === false && cssMtrNew02 === false && cssMtrNew03 === false && (
                                                    <div className="card your-promotion mt-3 p-3 p-md-4">
                                                        <div className="row">
                                                            ไม่มีสิทธิประโยชน์ของคุณในขณะนี้
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row mb-5 px-2">
                                            <div className="col-md-12">
                                                <h3 className="fw-semibold">สิทธิพิเศษของคุณ</h3>
                                                {rewards.length > 0 ? (
                                                    rewards.map((item, index) => (
                                                        <div className="card mt-3 p-3" key={index}>
                                                            <div className="row">
                                                                <div className="col-3 col-md-2 text-center p-0">
                                                                    <div className="m-0"><img src={`media/rewards/mtr/${item.displayImg01}`} alt="benefit" className="img-fluid" /></div>
                                                                </div>
                                                                <div className="col-9 col-md-10">
                                                                    <p className="mb-1 text-green-1"><strong>{item.promotionNameTh}</strong></p>
                                                                    <p className="text-black small mb-1">{item.rewardDescriptionThai}</p>
                                                                </div>
                                                            </div>
                                                            <hr />
                                                            <div className="row">
                                                                <div className="col-3 col-md-3 text-center px-0">
                                                                    <p className="mb-1 text-gray-2 small">Status</p>
                                                                    <p className="fw-semibold">{item.status}</p>
                                                                </div>
                                                                <div className="col-3 col-md-3 text-center px-0">
                                                                    <p className="mb-1 text-gray-2 small">Start</p>
                                                                    <p className="fw-semibold">{item.startDate}</p>
                                                                </div>
                                                                <div className="col-3 col-md-3 text-center px-0">
                                                                    <p className="mb-1 text-gray-2 small">Expires</p>
                                                                    <p className="fw-semibold">{item.expiryDate}</p>
                                                                </div>
                                                                <div className="col-3 col-md-3 text-center px-0">
                                                                    <p className="mb-1 text-gray-2 small">QTY</p>
                                                                    <p className="fw-semibold">{item.frequencyAvailable}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="card your-promotion mt-3 p-3 p-md-4">
                                                        <div className="row">
                                                            ไม่มีสิทธิพิเศษของคุณในขณะนี้
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row mb-5 px-2">
                                            <div className="col-md-12">
                                                <h3 className="fw-semibold">โปรโมชั่นของคุณ</h3>
                                                {promotions.length > 0 ? (
                                                    promotions.map((promotion, index) => (
                                                        <div key={index} className="card your-promotion mt-3 p-3 p-md-4">
                                                            <div className="row">
                                                                <div className="col-12 col-md-8">
                                                                    <p className="mb-1"><strong>{promotion.name}</strong></p>
                                                                    <p className="text-gray-2 small">
                                                                        {promotion.thaiText1} {promotion.thaiText2} {promotion.thaiText3} {promotion.thaiText4} {promotion.thaiText5} {promotion.thaiText6}
                                                                    </p>
                                                                </div>
                                                                <div className="col-6 col-md-2 text-center px-0">
                                                                    <p className="mb-1 text-gray-2 small">Start</p>
                                                                    <p className="fw-semibold">{promotion.displayPromotionStartDate}</p>
                                                                </div>
                                                                <div className="col-6 col-md-2 text-center px-0">
                                                                    <p className="mb-1 text-gray-2 small">End</p>
                                                                    <p className="fw-semibold">{promotion.displayPromotionEndDate}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="card your-promotion mt-3 p-3 p-md-4">
                                                        <div className="row">
                                                            ไม่มีโปรโมชั่นของคุณในขณะนี้
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row mb-5 px-2">
                                            <div className="col-md-8 offset-md-1">
                                                <h3 className="fw-semibold">ดาวสะสมที่จะหมดอายุ</h3>
                                                <div className="card mt-3 p-3 p-md-4">

                                                    <div className="row">
                                                        <div className="col-10"><p className="mb-1 small"><strong>ดาวสะสมที่ใกล้หมดอายุในเดือนนี้</strong></p></div>
                                                        <div className="col-2 text-center mb-2"><img src="media/rewards/SR_Stars_gold_large.svg" alt="Expiring in This month" className="img-fluid" style={{ width: '15px' }} /></div>
                                                    </div>
                                                    {transactionThismonth.length > 0 ? (
                                                        <>
                                                            {transactionThismonth.map((item, index) => (
                                                                <div className="row" key={index}>
                                                                    <div className="col-10"><p className="mb-1"><strong>{item.expiryDateLabel}</strong></p></div>
                                                                    <div className="col-2 text-center"><p className="mb-3 fw-semibold">{item.starRewardExpiration}</p></div>
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <p>ยังไม่มีดาวสะสมที่ใกล้หมดอายุ</p>
                                                    )}
                                                    <hr className="mt-2 mb-4" />

                                                    <div className="row">
                                                        <div className="col-10"><p className="mb-1 small"><strong>ดาวสะสมที่ใกล้หมดอายุ</strong></p></div>
                                                        <div className="col-2 text-center mb-2"><img src="media/rewards/SR_Stars_gold_large.svg" alt="Expiring Soon" className="img-fluid" style={{ width: '15px' }} /></div>
                                                    </div>
                                                    {transactionExpire.length > 0 ? (
                                                        <>
                                                            {transactionExpire.map((item, index) => (
                                                                <div className="row" key={index}>
                                                                    <div className="col-10"><p className="mb-1"><strong>{item.expiryDateLabel}</strong></p></div>
                                                                    <div className="col-2 text-center"><p className="mb-3 fw-semibold">{item.starRewardExpiration}</p></div>
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <p>ยังไม่มีดาวสะสมที่ใกล้หมดอายุ</p>
                                                    )}
                                                    <hr className="mt-2 mb-4" />

                                                    <div className="row">
                                                        <div className="col-10"><p className="mb-1 small text-gray-2"><strong>ดาวที่หมดอายุแล้ว</strong></p></div>
                                                        <div className="col-2 text-center mb-2"><img src="media/rewards/SR_Stars_gold_large.svg" alt="Expiring Soon" className="img-fluid" style={{ width: '15px' }} /></div>
                                                    </div>
                                                    {transactionExpired.length > 0 ? (
                                                        <>
                                                            {transactionExpired.map((item, index) => (
                                                                <div className="row" key={index}>
                                                                    <div className="col-10"><p className="mb-1 text-gray-2"><strong>{item.expiryDateLabel}</strong></p></div>
                                                                    <div className="col-2 text-center"><p className="mb-3 text-gray-2 fw-semibold">{item.starRewardExpiration}</p></div>
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                            <p className="mb-3 text-gray-2 fw-semibold">No star expiring.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                )}

                <ThNavFooter />
            </>
        );
    }
}